import Component from '../../components/Component';

import query from './query';
import { keys, keysPage } from './keys';
import ListData from '../../components/ListData';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor(props) {
        super();
        this.query = query(props.page);
    }

    render() {
        const { t } = this.props;
        const data = this.state.data?.length
            ? this.state.data?.sort((a, b) => b.sum_impressions - a.sum_impressions)?.slice(0, 10)
            : [];

        const dataKeys = this.props.page ? keysPage(t) : keys(t);
        return (
            <>
                <ListData
                    loading={this.state.loading}
                    header={this.props.header ?? t('discover.overview.top_categories.header')}
                    subheader={
                        this.props.subheader ?? t('discover.overview.top_categories.subheader')
                    }
                    forceRun={this.forceRun}
                    link={`/domains/${this.props.domain_id}/categories`}
                    keys={dataKeys}
                    uniqKey="level"
                    data={data}
                    itemClassName={this.props.page ? 'justify-content-start' : ''}
                    cardClassName={'list-data-full'}
                    customEmptyMessage={this.props.error_message}
                />
            </>
        );
    }
}

export default withTranslation()(Summary);
